import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UserRememberState } from '../types/userRemember.types'

const initialState: UserRememberState = {
  username: '',
  password: '',
  rememberMe: false,
}

const authUserSlice = createSlice({
  name: 'authRemember',
  initialState,
  reducers: {
    setAuthUser(state, action: PayloadAction<UserRememberState>) {
      state.username = action.payload.username
      state.password = action.payload.password
      state.rememberMe = action.payload.rememberMe
    },
    clearAuthUser(state) {
      state.username = ''
      state.password = ''
      state.rememberMe = false
    },
  },
})

export const { setAuthUser, clearAuthUser } = authUserSlice.actions
export default authUserSlice.reducer
